// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export type TraduccionCmpSecondaryTabCmpDataRetentionInfoParams = Record<"dias", string>;

export class TraduccionCmpSecondaryTabCmpDataRetentionInfo extends TraduccionLiteral<TraduccionCmpSecondaryTabCmpDataRetentionInfoParams> {
    /* STATIC */
    protected static override readonly ID: string = "cmp.secondary_tab.cmp_data_retention_info";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpSecondaryTabCmpDataRetentionInfo {
        this.VALUES ??= this.completar({
            "valor": {
                "da": "Vi opbevarer dine data i {{dias}} dage",
                "de": "Wir speichern Ihre Daten für {{dias}} Tage",
                "en": "We store your data for {{dias}} days",
                "es": "Almacenamos sus datos durante {{dias}} días",
                "fr": "Nous conservons vos données pendant {{dias}} jours",
                "it": "Conserviamo i tuoi dati per {{dias}} giorni",
                "nl": "We bewaren uw gegevens {{dias}} dagen",
                "pt": "Armazenamos seus dados por {{dias}} dias",
                "ru": "Мы храним ваши данные в течение {{dias}} дней",
                "pt-BR": "Armazenamos seus dados por {{dias}} dias"
            },
            "defecto": "Almacenamos sus datos durante {{dias}} días"
        }, idiomas);

        return super.build(lang, this.VALUES, ["dias"]);
    }

    /* INSTANCE */
}
